document.addEventListener("DOMContentLoaded", () => {
  const toggleButtons = document.querySelectorAll(".upsell-module-container__toggle");

  toggleButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const tab = button.closest(".upsell-module-container__tab");
      if (tab) {
        tab.classList.toggle("upsell-module-container__tab--expanded");
      }
    });
  });
});
